import React, { useState, useEffect, useContext, useRef, Fragment } from "react";
import "./styles.css";
import ConfHeader from "./components/ConfHeader";
import ConfFooter from "./components/ConfFooter";
import ScreenShare from "./components/ScreenShare";
import WhiteBoard from "./components/WhiteBoard";
import ScreenShareViewVideo from "./view/screenShareView";
import { useHistory } from 'react-router-dom';
import { FileCtx, InstavcCtx, GroupChatCtx, localRecordingCtx } from "../../lib/context";
import UploadFileView from "../common/fileUploads/components/uploadFileView";
import LoadingConference from "./components/LodingConference";
import { enterParticipantLogs, exitParticipantLogs } from "../../actions/appointment";
import { toast } from 'react-toastify';
import ConfirmEndCall from "./components/ConfirmEndCall";
import { sendPrescription } from "../../actions/schedule";
import ViewVideos from './view/viewVideos';
import NewViewVideos from './view/newViewVideos';
import CombinedViewVideo from './view/combinedViewVideos';
import getUserAgentData from "./sdklib/deviceInfo";
import AudioPeers from "./view/audioPeers";


const Conference = (props) => {
    const { id, appointmentData, instaVC, query_data, role, payload } = props;
    const history = useHistory();
    const [selFile, setFileView] = useState(null);
    const [currentScreen, setCurrentScreen] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [screenStream, setScreenStream] = useState(null);
    const [joined, setJoined] = useState(false);
    const record = useContext(localRecordingCtx);
    const [loadScreen, setLoadScreen] = useState(true);
    const [endCall, setEndCall] = useState(false);
    const [selfVideo, setSelfVideo] = useState(null);
    const [peers, setPeers] = useState([]);
    const [consumers, setConsumers] = useState([]);
    const [audioOutputDevice, setAudioOutputDeviceId] = useState(null);
    const [chatData, setChatData] = useState([]);
    const chatDataRef = useRef(chatData);
    const screensVideoContainerRef = useRef(null);
    const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

    const headerRef = useRef(null);
    let name = payload && payload.firstName ? payload.firstName : query_data && query_data.name ? query_data.name : '';
    name += payload && payload.lastName ? " " + payload.lastName : "";
    const email = payload && payload.email ? payload.email : query_data && query_data.email ? query_data.email : '';


    useEffect(() => {
        if (((query_data && query_data.email) || (payload && payload.email)) && appointmentData && appointmentData.appointmentId && instaVC && !joined) {
            const body = {
                email: payload && payload.email ? payload.email : query_data && query_data.email ? query_data.email : '',
                appointmentId: appointmentData.appointmentId,
                enterUTC: new Date().valueOf(),
                guest: !role || role === ""
            }

            const formDataObject = {
                name: name,
                userName: email,
                roomId: appointmentData.appointmentId,
                connectoptions: 'both',
                isHost: role === "D"
            }
            enterParticipantLogs(body).then((res) => {
                if (res.status) {
                    setStartTime(res.data.enterUTC)
                }
            }).catch(err => {
                console.log('error at enterParticipants logs-----' + err.errorMessage)
            });

            instaVC.addEventListener('onError', (error) => {
                console.log("on error ==== ", error);
                setJoined(false);
            });

            instaVC.addEventListener('consumer-received', (consumerData) => {
                console.log("consumer received ==== ", consumerData);
                if (consumerData.source === "screen") {
                    const stream = new MediaStream();
                    stream.addTrack(consumerData.track)
                    setScreenStream(stream);
                    setCurrentScreen("SSS");
                }
                setConsumers(prevState => [...prevState, consumerData]);
            });

            instaVC.addEventListener('newPeer', (peerinfo) => {
                setPeers(prevState => [...prevState, peerinfo.data]);

            });
            instaVC.addEventListener('peerclosed', (peerinfo) => {
                setPeers(prevState => [...prevState].filter((each) => {
                    return each.id !== peerinfo.data.peerId
                }
                ));
            });
            instaVC.addEventListener('Joined', (res) => {
                setLoadScreen(false);
                if (res && res.peerList && res.peerList.length > 0) {
                    setPeers([...res.peerList]);
                }
            });


            instaVC.addEventListener('moderator:closeMeeting', (res) => {
                console.log("closeMeeting triggered")
                role==="P"?history.push("/feedback", { appointmentData }):history.push("/");
            });

            instaVC.addEventListener('message-received', (message) => {
                processMessage(message);
            });


            instaVC.addEventListener('connected', (res) => {
                setJoined(true);
            });

            instaVC.addEventListener('disconnected', (res) => {
                console.log('disconnected ==== ', res);
                console.log('Instavc disconnected ==== ', res?.reason);
                setConsumers([])
                setPeers([])
                setAudioOutputDeviceId(null)
                setSelfVideo(null)
            });

            instaVC.addEventListener('reconnect', (res) => {
                // setJoined(true);
            });
            instaVC.addEventListener('screenshare-stopped', (res) => {
                setCurrentScreen(null);
            });

            instaVC.addEventListener('reconnect_failed', (res) => {
                console.log('reconnect_failed in conference==== ', res);
            });

            instaVC.addEventListener('stream', (res) => {
                if (res && res.stream) {
                    setSelfVideo(res.stream);
                }
            });
            instaVC.addEventListener('selfScreen', (res) => {
                setCurrentScreen("SSS");
                setScreenStream(res.stream)

            });

            instaVC.addEventListener('closeProducer', (res) => {
                if (res && res?.type === 'webcam') {
                    setSelfVideo(null);
                }
            });

            instaVC.addEventListener('activeSpeaker-changed', (res) => {

            });
            // instaVC.addEventListener('consumerClosed', removeConsumer);



            instaVC.addEventListener('audioOutputDevice', (deviceId) => {
                setAudioOutputDeviceId(deviceId)
            });

            if (!instaVC._connectionSocket) {
                instaVC.connect(formDataObject).then(() => {
                });
            }

        }

        window.addEventListener('beforeunload', (e) => {
            // instaVC.clearConference();
        });

        window.addEventListener('popstate', async (e) => {
            // instaVC.clearConference();
             await instaVC.close();
        });

        return () => {
        }
    }, [payload, appointmentData, instaVC, joined]);


    useEffect(() => {
        function removeConsumer(id) {

            const currentconsumer = consumers.filter(each => each.id === id);
            if (currentconsumer[0].source === "screen") {
                setCurrentScreen(null);
            }
            setConsumers(consumers.filter(each => each.id !== id))

        }
        instaVC.addEventListener('consumerClosed', removeConsumer);
        return () => {
            instaVC.removeEventListener('consumerClosed', removeConsumer);
        }
    }, [instaVC, consumers]);


    const processMessage = async (message, sender) => {


        let ele = document.getElementById("videoArea");

        switch (message.data.messageType) {
            case 'CMD':
                switch (message.data.message) {
                    case 'CALLEND': instaVC.clearConference();
                        if (role === "D") {
                            headerRef.current.saveLog(id);
                        }
                        if (payload && payload.userId !== message.userId) {
                            record?.localRecording && await record.stopRecording();
                            record?.cloudRecording && await record.stopCloudRecording();
                            let senderName = appointmentData && appointmentData.doctorId === message.userId ? `Dr. ${message.senderName}` : message.senderName;
                            toast.success(`Call ended by ${senderName}`, {
                                position: toast.POSITION.TOP_RIGHT
                            })
                        }
                        history.push("/");
                        break;
                    case 'OPENWB':
                        if (ele) {

                            ele.className = ele.className.replace(" ssbtmVideos", "")
                            ele.className += " ssbtmVideos";
                        }

                        setCurrentScreen("WB");

                        break;
                    case 'CLOSESCREEN': if (ele) {
                        ele.className = ele.className.replace(" ssbtmVideos", "")
                    }
                        setCurrentScreen(null);
                        break;
                    case 'GROUPCHAT':
                        let _data = [...chatDataRef.current];
                        _data.push(message.data);
                        chatDataRef.current = [..._data];

                        setChatData([..._data]);
                        break;
                    default: return;
                }
                break;
            default: return;
        }
    }
    const handleEndCall = async (callStatus = false) => {
        console.log("appointmentData === ", appointmentData);
        let body = {
            appointmentId: appointmentData.appointmentId,
            enterUTC: startTime,
            exitUTC: new Date().valueOf(),
            callStatus: callStatus
        }

        record?.localRecording && await record.stopRecording();
        record?.cloudRecording && await record.stopCloudRecording();


        exitParticipantLogs(body).then((res) => {
            if (res.status) {
            }
        }).then(() => {

            if (callStatus === true) {

                sendPrescription(appointmentData.appointmentId).then((res) => {

                }).catch((err) => {
                    console.log("Error while sending sms", err)
                })

            }

        }).catch(err => {
            console.log('error at exitParticipants logs-----' + err.errorMessage)
        });
        if (role === "D") {
            console.log("meeting end by doctor")
            await instaVC.closeMeeting();
            console.log("meeting end by doctor")
        } else {
            instaVC.close();
            if (role === "P") {
                history.push("/feedback", { appointmentData });
            } else {
                history.push("/");
            }
        }
    }


    useEffect(() => {
        if (screensVideoContainerRef.current) {
            const { width, height } = screensVideoContainerRef.current.getBoundingClientRect();
            setContainerSize({ width, height });
        }
    }, [currentScreen]);


    const syncCommand = (message, cmd = 'CMD') => {
        const _txtCommand = {
            message: message,
            senderName: name,
            senderEmail: 'email',
            userId: payload && payload.userId ? payload.userId : '',
            messageType: cmd
        }
        instaVC.sendMessageToRoom(_txtCommand);
    }

    const handleScreenShare = async () => {
        if (instaVC._screenSharingProducer) {
            await instaVC.disableScreenSharing();
        } else {
            try {
                await instaVC.updateScreenSharing({ start: true });
                setCurrentScreen("SSS");
            } catch (error) {
                console.error("Screen share canceled or failed:", error);
            }
        }
    };
    console.log("ssssssssssssssssssssssssss", currentScreen);
    return <Fragment>
        <FileCtx.Provider value={{ selFile, setFileView }}>
            <InstavcCtx.Provider value={{ instaVC, appointmentData }}>
                <div className="confContainer">
                    {loadScreen && <LoadingConference />}
                    <ConfHeader ref={headerRef} role={role} handleEndCall={() => setEndCall(true)} />
                    <div className={currentScreen !== null ? "confBody-srn" : "confBody"}>
                        <div className={currentScreen !== null ? "conf169Box-srn" : "conf169Box"}>
                            {currentScreen === "SSS" &&
                                <ScreenShare handleClose={() => syncCommand("CLOSESCREEN")} isHost={role === "D"}
                                    screenStream={screenStream} />

                            }
                            {currentScreen === "WB" &&
                                <WhiteBoard handleClose={() => syncCommand("CLOSESCREEN")} roomId={appointmentData?.appointmentId ? appointmentData.appointmentId : ''} name={name} isHost={role === "D"} />
                            }
                            <div ref={screensVideoContainerRef} className={currentScreen !== null ? "screensVideoContainer" : "confVideoContainer"}>
                                {currentScreen !== null ? (
                                    <ScreenShareViewVideo selfVideo={selfVideo} peers={peers} consumers={consumers} containerWidth={containerSize?.width} containerHeight={containerSize?.height} />
                                ) : 
                                     <CombinedViewVideo selfVideo={selfVideo} peers={peers} consumers={consumers} containerWidth={containerSize?.width} containerHeight={containerSize?.height} headless={instaVC._headless} />
                                }
                            </div>
                            <div>
                                {
                                    consumers && consumers.length > 0 && consumers.map((each) => {
                                        if (each?.kind === 'audio') {
                                            return <AudioPeers
                                                key={each.id}
                                                audioTrack={each.track}
                                                audioOutputDevice={audioOutputDevice}
                                                audioGain={each.audioGain}
                                                browser={getUserAgentData()}
                                                audioContext={null}
                                            />
                                        }
                                    })

                                }
                            </div>
                        </div>
                    </div>
                    <GroupChatCtx.Provider value={{ chatData }}>
                        <ConfFooter payload={payload} name={name} email={email} handleScreen={syncCommand} handleScreenShare={handleScreenShare} data={appointmentData} handleEndCall={() => setEndCall(true)} currentScreen={currentScreen} />
                    </GroupChatCtx.Provider>
                </div>
            </InstavcCtx.Provider>
        </FileCtx.Provider>
        {endCall && <ConfirmEndCall openConfirmation={endCall} handleClose={(e) => setEndCall(false)} handleEndCall={handleEndCall} />}
        {selFile !== null && <UploadFileView open={selFile !== null} handleClose={() => setFileView(null)} data={selFile} />}

    </Fragment>
}

export default Conference;
